<template>
  <nav-bar title="监管企业" />
  <div class="top-fixed van-hairline--bottom">
    <van-row gutter="20">
      <van-col span="12">
        <van-button type="primary" block to="/newEnterprise"
        >新建监管企业</van-button
      >
      </van-col>
      <van-col span="12">
        <van-button type="primary" block to="/regulatoryEnterpriseStatistics"
        >监管企业统计</van-button
    >
      </van-col>
    </van-row>
    <van-search v-model="word" placeholder="请输入搜索关键词" @search="handleSearch" />
  </div>
  <Content :bottom="0" :top="173" @content-scroll="handleContentScroll">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getList"
    />
    <ul class="list">
      <li
        class="list-item"
        v-for="item in list"
        :key="item.companyId"

      >
        <div class="list-item__companyName" @click="$router.push(`/userInfo/${item.userId}`)">
          <span><van-icon name="wap-home-o" /></span>
          <span>{{ item.companyName }}</span>
          <van-tag :type="item.userType === '1' ? 'primary' : 'danger'">{{item.userType === '1' ? '合法' : '非法'}}</van-tag>
        </div>
        <div class="list-item__contect">
          <div class="contect-text"><span><van-icon name="user-o" /></span>{{item.userName}}</div>
          <div class="contect-text"><span><van-icon name="phone-o" /></span>{{item.phoneNum}}</div>
        </div>
        <div v-if="item.comName" class="list-item__supplier">
          <span>供应商：</span>
          <span>{{item.comName}}</span>
        </div>
        <div class="list-item__check" v-if="item.userType === '0'">
          <van-row v-if="item.checkFlag === '1'" gutter="20">
            <van-col span="12">
              <van-button  block type="default" size="small" :to="`/inspectionResults/${item.checkResultId}`">上次检查：{{item.checkDate}}</van-button>
            </van-col>
            <van-col span="12">
              <van-button block type="primary" size="small" :to="`/inspection/01/1/${item.userId}`">检查</van-button>
            </van-col>
          </van-row>
          <van-button v-else block type="primary" size="small" :to="`/inspection/01/1/${item.userId}`">检查</van-button>
        </div>
        <div class="list-item__btns">
          <van-button block type="warning" v-if="item.accordFlag === '0'" class="btn-2" size="small" @click="toastInfo(item.accordRemark)">信息不符</van-button>
          <van-button block type="success" v-if="item.accordFlag === '2'" class="btn-2" size="small" :to="`/informationConfirmation/${item.userId}`">已修改</van-button>
          <van-row class="btn-2" v-if="item.userStatus === '05'" gutter="20">
            <van-col span="12">
              <van-button block color="#7232dd"   size="small" :to="`/modifyRegulatoryUser/${item.userId}`">基本信息修改</van-button>
            </van-col>
            <van-col span="12">
              <van-button block color="#7232dd"   size="small" @click="handleModClick(item.userId)">合同修改</van-button>
            </van-col>
          </van-row>
          <van-button block type="danger" size="small" @click="handleDelClick(item.userId)">删除</van-button>
        </div>

      </li>
    </ul>
    <loading-more :finished="finished" :showLoadingMore="showLoadingMore" :loadingFail="loadingFail" :list="list" @reload="getList" />
  </Content>
  <Popup title="合同修改" minHeight="100%" ref="popup">
    <van-form>
      <Picker
          label="合同开始时间"
          pickerType="time"
          :defaultVal="contractSdate"
          @confirm-values="val => contractSdate = val"
        />
      <Picker
        label="合同结束时间"
        pickerType="time"
        :defaultVal="contractEdate"
        :maxDate="afterYear(5)"
        @confirm-values="val => contractEdate = val"
      />
      <Field
        name="handlerName"
        label="经办人"
        :require="true"
        :disabled="disabled"
        :defaultValue="handlerName"
      />
      <Field
        name="handlerTel"
        label="经办人电话"
        :require="true"
        :disabled="disabled"
        :defaultValue="handlerTel"
      />
      <van-field name="uploader" >
        <template #input>
          <van-uploader  v-model="fileList" :after-read="afterRead" :show-upload="showUpload"   />
        </template>
      </van-field>
      <div class="btn">
        <van-button
          block
          type="primary"
          :loading="loading"
          loading-text="请稍后..."
          :disabled="loading"
          native-type="button"
          @click="onSubmit"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </Popup>
</template>

<script>
import { Dialog, Notify, Toast } from 'vant'
import { ref, computed } from 'vue'
import { queryCustomerListByStId, deleteCustomerById } from '@/api/superviseHome'
import { useStore } from 'vuex'
import { getCustomerDetail, batchAddUserContract } from '@/api/customer'
import getImgFile from '@/utils/getImgFile'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { afterYear } from '@/utils/common'
export default {
  name: 'RegulatoryEnterprise', // 监管企业
  setup() {
    const store = useStore()
    const stId = computed(() => store.state.roleInfo.companyId)
    const tenantId = computed(() => store.state.roleInfo.tenantId)
    // console.log(store.state.roleInfo)
    const data = useLoadingMore(queryCustomerListByStId)
    const {
      getList,
      list,
      finished,
      loadingFail,
      pageParams
    } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.page = 1
      pageParams.stId = stId.value
      pageParams.tenantId = tenantId.value || ''
      finished.value = false
      loadingFail.value = false

      getList()
    }
    init()
    const word = ref('')
    const handleSearch = (val) => {
      pageParams.comName = val
      init()
    }
    // 删除
    const handleDelClick = (id) => {
      Dialog.confirm({
        title: '删除',
        message: '确定要删除该条记录？'
      })
        .then(() => {
          // on confirm
          delItem(id)
        })
        .catch(() => {
          // on cancel
        })
    }
    const delItem = async (id) => {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: '请稍后...'
      })
      try {
        const { status } = await deleteCustomerById(id)
        if (status === 200) {
          Notify({ type: 'success', message: '删除成功' })
          init()
        } else {

        }
        Toast.clear()
      } catch {
        Toast.clear()
      }
    }
    const toastInfo = (message) => {
      Toast(message)
    }
    const popup = ref(null)
    const userId = ref('')
    const contractSdate = ref('')
    const contractEdate = ref('')
    const handlerName = ref('')
    const handlerTel = ref('')
    const handleModClick = (id) => {
      userId.value = id
      getCustomerDetail(id).then(res => {
        fileList.value = res.data.imgList ? res.data.imgList.map(item => ({ url: item, status: 'done' })) : []
        contractSdate.value = res.data.contractSdate
        contractEdate.value = res.data.contractEdate
        handlerName.value = res.data.handlerName
        handlerTel.value = res.data.handlerTel
      })
      popup.value.showPopup()
    }
    // 文件上传
    const fileList = ref([])
    const showUpload = ref(true)
    const imgPath = computed(() => {
      const arr = []
      fileList.value.forEach(item => {
        if (item.status === 'done') {
          arr.push(item.content || item.url)
        }
      })
      return arr
    })
    const afterRead = (file) => {
      getImgFile(file, fileList, showUpload)
    }
    const loading = ref(false)
    const onSubmit = () => {
      loading.value = true
      batchAddUserContract({
        userId: userId.value,
        imgList: imgPath.value,
        contractSdate: contractSdate.value,
        contractEdate: contractEdate.value,
        handlerTel: handlerTel.value,
        handlerName: handlerName.value
      }).then(() => {
        popup.value.hidePopup()
        loading.value = false
        Notify({ type: 'success', message: '操作成功' })
      }).catch(() => {
        loading.value = false
      })
    }
    return { handleDelClick, toastInfo, popup, handleModClick, imgPath, afterRead, showUpload, fileList, onSubmit, loading, ...data, handleSearch, word, contractSdate, contractEdate, afterYear, handlerTel, handlerName, tenantId }
  }
}
</script>

<style lang="scss" scoped>
.top-fixed {
  margin: 16px;
  margin-bottom: 0;
  ::v-deep(.van-search) {
   padding: 16px 0 !important;
  }
}

.btn {
  margin: 16px;
}
.btn-2 {
  margin-bottom: 16px;
}
.list {
  padding: 16px;
  padding-bottom: 0;
  font-size: 14px;
  color: #666;
  .list-item {
    padding: 14px;
    background-color: #fff;
    box-shadow: rgba(87, 107, 146, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    &__companyName {
      font-weight: 600;
      line-height: 22px;
      span {
        margin-right: 5px;
      }
    }
    &__contect {
      display: flex;
      font-size: 12px;
      margin-top: 15px;
      .contect-text {
        flex: 1;
        span {
          margin-right: 5px;
        }
      }
    }
    &__supplier {
      margin-top: 15px;
      border: 1px dotted #ccc;
      padding: 5px;
      font-size: 12px;
      line-height: 14px;
      color: #999;

    }
    &__check {
       margin-top: 15px;
    }
    &__btns {
      margin-top: 15px;
    }
  }
}
</style>
